import useScrollReveal from "../hooks/useScrollReveal";
import usePageMeta from "../hooks/usePageMeta";
import Navbar from "../components/Navbar";
import Hero from "../components/sections/Hero";
import Services from "../components/sections/Services";
import WhyChoose from "../components/sections/WhyChoose";
import AdditionalServices from "../components/sections/AdditionalServices";
import Pricing from "../components/sections/Pricing";
import Portfolio from "../components/sections/Portfolio";
import Testimonials from "../components/sections/Testimonials";
import FAQ from "../components/sections/FAQ";
import Contact from "../components/sections/Contact";
import Footer from "../components/sections/Footer";

export default function Home() {
  useScrollReveal();
  usePageMeta({
    title:
      "ZF Industries — Montage PC Gaming sur mesure à Paris & Meudon (92)",
    description:
      "Montage de PC gaming sur mesure, pose seule dès 80€ ou clé en main selon votre budget. Devis écrit, prix garanti, câblage soigné, livraison France. Atelier à Meudon (92).",
  });
  return (
    <main data-testid="home-page" className="relative">
      <Navbar />
      <Hero />
      <Services />
      <WhyChoose />
      <AdditionalServices />
      <Pricing />
      <Portfolio />
      <Testimonials />
      <FAQ />
      <Contact />
      <Footer />
    </main>
  );
}
